import {
  NEW_REFERRING_PHYSICIAN_OPTION,
  PhysicianOption,
} from "./physician-field.component";

export default function createPhysicianFromInput(
  inputValue: string
): PhysicianOption {
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const isPhoneNumber =
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/im;

  const newPhysician: PhysicianOption = NEW_REFERRING_PHYSICIAN_OPTION;

  if (isEmail.test(inputValue)) {
    newPhysician.email = inputValue;
  } else if (isPhoneNumber.test(inputValue)) {
    newPhysician.phone = inputValue;
  } else {
    const splitInput = inputValue.split(" ");
    if (splitInput.length === 2) {
      newPhysician.first_name = splitInput[0];
      newPhysician.last_name = splitInput[1];
    } else {
      newPhysician.first_name = inputValue;
    }
  }
  return newPhysician;
}
